module.exports = __webpack_public_path__ + "static/media/solarIcon.5f556862.svg";